export default "__VITE_ASSET__9379a0c4__"